var _ellipse, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurerPortion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7346,
    cy: 16,
    rx: 16.0901,
    ry: 16,
    fill: "#0781DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7894 15.7529C13.5922 17.6647 12.6211 19.566 12.6211 21.787C12.6211 23.2925 13.7792 24.6834 15.6602 25.4366C17.5412 26.1878 19.8577 26.1878 21.7369 25.4366C23.6179 24.6834 24.776 23.2927 24.776 21.788L24.7821 21.787C24.7821 19.566 23.8107 17.6632 22.6155 15.7529H14.7894ZM18.2255 17.62H19.1782V18.3561C19.6405 18.4243 20.076 18.6168 20.4234 18.8929C20.2662 19.0448 19.9548 19.3462 19.7976 19.4978L19.6046 19.3839C19.1288 19.0656 18.3654 19.0553 17.9543 19.4626C17.7012 19.7022 17.7282 20.1581 18.0997 20.2946C18.5496 20.4693 19.0647 20.4779 19.5149 20.6584C20.1703 20.8666 20.5834 21.4702 20.5653 22.0701C20.5713 22.7379 19.889 23.2591 19.1782 23.3752V24.1335H18.2255V23.4014C17.8316 23.3546 17.4489 23.2407 17.0953 23.0798C17.2389 22.8387 17.3843 22.5976 17.5279 22.357C17.8046 22.4445 18.1413 22.582 18.4706 22.5908C18.8628 22.6149 19.3489 22.5521 19.5721 22.2338C19.6528 22.0231 19.6422 21.7334 19.4385 21.5763C18.9895 21.2987 18.414 21.2884 17.9095 21.13C17.3168 20.9611 16.8617 20.4716 16.841 19.9215C16.781 19.1981 17.4455 18.5515 18.2255 18.3918V17.62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1094 6H22.3799V7.02931L20.7055 8.45788L16.7835 8.45939L15.1094 7.02931V6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4772 8.20508L12.2195 9.78022V12.1373H11.355V9.78022H8.69141V14.1904H12.2195L14.3507 14.8976H22.0912V14.0898H20.2327V13.4731H22.0912V12.6663H20.2327V12.051H22.0912V11.2447H20.2327V10.6288H22.5659L23.0238 10.2846V9.41793L22.5659 9.07323L16.4966 9.07474L15.4772 8.20508Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurerPortion);
export default __webpack_public_path__ + "static/media/insurerPortion.8210d23e39cc08c6c46b487502cffbc8.svg";
export { ForwardRef as ReactComponent };